import { FC, memo } from "react"
import { useMediaQuery } from "../../hooks"

type Props = {
  //
}

const InstantPayoutsBlockComponent: FC<Props> = () => {
  const isMobile = useMediaQuery("(max-width: 768px)")

  return (
    <div style={{ background: "url(/img/icons_new/instant_bg.png) #fafafa bottom no-repeat" }}>
      <div
        className="container"
        style={{
          padding: `90px ${isMobile ? "15px" : "0"} 62px`,
          display: "flex",
          flexDirection: "column",
          gap: "46px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
          <h2
            className="how__title title text-sm-center"
            style={{
              textAlign: "center",
              maxWidth: "860px",
              alignSelf: "center",
              marginBottom: 0,
            }}
          >
            Instant Payouts / How to Get Your Crypto in Cash Instantly{" "}
            <span
              style={{
                backgroundColor: "#0021a0",
                fontSize: "0.6em",
                color: "white",
                borderRadius: 40,
                padding: "4px 16px",
              }}
            >
              Soon available
            </span>
          </h2>
          <span
            style={{ textAlign: "center", fontSize: "24px", lineHeight: "115%", fontWeight: 500, maxWidth: "770px", alignSelf: "center" }}
          >
            Transfer your Bitcoin directly to your debit card and have the money in your bank account without delay.
          </span>

          <button
            style={{
              border: "none",
              outline: "none",
              minHeight: "42px",
              borderRadius: "70px",
              alignSelf: "center",
              padding: "10px 30px",
              backgroundColor: "#FC141C",
              color: "#ffffff",
            }}
          >
            Here’s how to convert your BTC to a debit card:
          </button>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "32px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <span style={{ textAlign: "center", fontSize: "60px", lineHeight: "115%", fontWeight: 900 }}>01</span>
            <span
              style={{ textAlign: "center", fontSize: "32px", lineHeight: "115%", fontWeight: 800, maxWidth: "380px", alignSelf: "center" }}
            >
              Initiate a new transaction – Bitcoin to Debit Card
            </span>
          </div>

          <img src="./img/icons_new/arrow.png" style={{ height: "28px", width: "16px", alignSelf: "center" }} alt="arrow" />

          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <span style={{ textAlign: "center", fontSize: "60px", lineHeight: "115%", fontWeight: 900 }}>02</span>
            <span
              style={{ textAlign: "center", fontSize: "32px", lineHeight: "115%", fontWeight: 800, maxWidth: "280px", alignSelf: "center" }}
            >
              Provide your debit card details.
            </span>
          </div>

          <img src="./img/icons_new/arrow.png" style={{ height: "28px", width: "16px", alignSelf: "center" }} alt="arrow" />

          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <span style={{ textAlign: "center", fontSize: "60px", lineHeight: "115%", fontWeight: 900 }}>03</span>
            <span
              style={{ textAlign: "center", fontSize: "32px", lineHeight: "115%", fontWeight: 800, maxWidth: "900px", alignSelf: "center" }}
            >
              Transfer your Bitcoin to the given address and watch for the funds to appear in your card. Most transfers happen instantly,
              but some banks may require extra time for processing.
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export const InstantPayoutsBlock = memo(InstantPayoutsBlockComponent)
